module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"wh100 table table-w-0-100-0\">\n    <div>\n        <div class=\"h100\" style=\"min-width: 300px;\">\n            <div class=\"cell__abs_container\">\n                <div class=\"cell__abs overflow-y__auto\" name=\"organizations-tree\">\n                </div>\n            </div>\n        </div>\n        <div style=\"vertical-align: top\">\n            <div class=\"wh100 table table-0-100\">\n                <div>\n                    <div name=\"filter\"></div>\n                </div>\n                <div>\n                    <div name=\"grid\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}